/**
 * F9 (raport uwag Bronka 2026-10-19, backend migr. 069): stan podpisu lokatora w formularzu lokalu panelu.
 * Panel tylko POKAZUJE tryb „Z upoważnienia (bez podpisu lokatora)" ustawiony na tablecie — formularz
 * panelu nie wysyła tych pól, więc zapis z panelu ich nie zmienia (backend: pominięte = zachowaj).
 * Tekst adnotacji = lustro backend/src/utils/authorizedSignature.js i mobile/src/utils/authorizedSignature.ts
 * (parytet: backend/test/airSignedByAuthorization.test.js).
 */

export const AUTHORIZATION_LABEL = 'Z upoważnienia';

/** Pola rekordu AIR (camelCase z GET /apartment-inspections/…) potrzebne do opisu podpisu. */
export interface SignatureStateRecord {
  ownerSignature?: string | null;
  signedByAuthorization?: boolean | null;
  authorizedBy?: string | null;
}

/** Opis podpisu lokatora: „Z upoważnienia: <osoba> (bez podpisu lokatora)" / „Podpisany…" / „Brak podpisu". */
export function signatureStateLabel(rec: SignatureStateRecord | null | undefined): string {
  if (rec && rec.signedByAuthorization === true) {
    const by = String(rec.authorizedBy ?? '').trim();
    return `${by ? `${AUTHORIZATION_LABEL}: ${by}` : AUTHORIZATION_LABEL} (bez podpisu lokatora)`;
  }
  return rec && rec.ownerSignature ? 'Podpisany przez lokatora na tablecie' : 'Brak podpisu';
}
